export default "__VITE_ASSET__BlNk81NW__"